import React, { Component } from 'react';
import { VideoSection } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The see how it works in action section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class SeeHowView extends Component {

	render () {
		const { heading1, heading2, videoId } = this.props.content.landingPage.seeHow;

		return (
			<VideoSection
				{...{
					heading1,
					heading2,
					videoId,
				}}
				className='SeeHowView'
			/>
		);
	}

}

export default withLanguageContext(SeeHowView);



// WEBPACK FOOTER //
// ./src/components/views/SeeHowView/SeeHowView.js